import { Icon, Img, SubTitle } from 'components';
import React, { useEffect, useState } from 'react';
import { Text, RowDiv, SubSection, ColDiv, Span, SubWrap } from 'styles';
import { SubLayout } from 'layout';
import * as S from './CompanyStyle';

export function Company({ setRef, langList }) {
  const [list, setList] = useState();
  const [loading, setLoading] = useState(true);
  const [currentNav, setCurrentNav] = useState();

  useEffect(() => {
    if (langList) {
      setCurrentNav(langList.nav.filter((el) => el.path.includes(window.location.pathname.split('/')[1]))[0]);
      setList(langList.company);
      setLoading(false);
    }
  }, [langList]);

  useEffect(() => {
    if (sessionStorage.getItem('currentIndex')) {
      setTimeout(
        () =>
          setRef.current[Number(sessionStorage.getItem('currentIndex'))].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          }),
        300,
      );
    }
  }, [sessionStorage.getItem('currentIndex'), setRef.current]);

  return (
    list && (
      <SubLayout list={list} setRef={setRef} nav={langList.nav}>
        <SubSection>
          <SubWrap $type="first" ref={(el) => (setRef.current[0] = el)}>
            <SubTitle title={list.subject1} desc={list.subject1Desc} />
            <RowDiv $gap={32} $tFlexDirection="column-reverse">
              <S.TextBox $padding="32px" $tPadding="0 32px" $mPadding="0 24px" $gap={24} $mGap={16}>
                <S.H4>{list.ceoTitle}</S.H4>
                <Text $type="b5" $tType="b6" $mType="b7">
                  {list.ceoDesc}
                </Text>
              </S.TextBox>
              <S.ImgBox>
                <Img src={list.ceoImg} alt={list.subject1} $objectFit="cover" />
              </S.ImgBox>
            </RowDiv>
          </SubWrap>
          <SubWrap ref={(el) => (setRef.current[1] = el)}>
            <SubTitle title={list.subject2} desc={list.subject2Desc} />
            <S.TextBox $padding="0 32px" $gap={32} $mPadding="0 24px" $mGap="0">
              <Text $type="h5" $mType="h7" $color="darkest">
                {list.profileTitle}
              </Text>
              <S.ProfileGrid>
                {list.profileDesc.map((item, index) => (
                  <ColDiv key={`desc_${index}`} $gap={12} $width="100%">
                    <Text $type="h5" $mType="h6" $color="primary" $fontWeight={700}>
                      {item.year}
                    </Text>
                    <ColDiv $gap={8} $paddingLeft={16}>
                      {item.items.map((desc, idx) => {
                        const isPatent = desc.startsWith('  •');
                        return (
                          <RowDiv key={`item_${idx}`} $gap={8} $alignItems="flex-start" $paddingLeft={isPatent ? 16 : 0}>
                            {!isPatent && <S.Circle />}
                            <Text $whiteSpace="pre" $type="b5" $tType="b6" $mType="b7" $flex={1} $color={isPatent ? 'darker' : 'darkest'}>
                              {desc.replace('  •', '•')}
                            </Text>
                          </RowDiv>
                        );
                      })}
                    </ColDiv>
                  </ColDiv>
                ))}
              </S.ProfileGrid>
            </S.TextBox>
          </SubWrap>
          <SubWrap ref={(el) => (setRef.current[2] = el)} $mGap="16px !important">
            <SubTitle title={list.subject3} desc={list.subject3Desc} />
            <Img src={list.organizationImg} alt={list.subject3} $width={1083} />
          </SubWrap>
          <SubWrap ref={(el) => (setRef.current[3] = el)} $mGap="16px !important">
            <SubTitle title={list.subject4} desc={list.subject4Desc} />
            <S.TextBox $padding="0 32px" $mPadding="0 24px" $mGap={16}>
              <Text $type="h5" $color="darkest">
                {list.LicensingDesc.text}
              </Text>
              <ul>
                {list.LicensingDesc.content.map((con, index) => (
                  <S.ListItem key={`con_${index}`}>
                    <S.Circle $color="strong" />
                    <Text $type="h5" $mType="h7" $color="primary">
                      {con.num} &nbsp;
                      <Span $type="b5" $mType="b7">
                        {con.text}
                      </Span>
                    </Text>
                  </S.ListItem>
                ))}
              </ul>
              {list.LicensingDesc.certifications && (
                <S.CertificationGrid>
                  {list.LicensingDesc.certifications.map((cert, index) => (
                    <S.CertificationItem key={`cert_${index}`}>
                      <Img src={cert} alt={`인증서 ${index + 1}`} $width="100%" $height="auto" />
                    </S.CertificationItem>
                  ))}
                </S.CertificationGrid>
              )}
            </S.TextBox>
          </SubWrap>
          <SubWrap ref={(el) => (setRef.current[4] = el)}>
            <SubTitle title={list.subject5} desc={list.subject5Desc} />
            <Img src={list.mapImg} alt={list.mapImg} $width={1083} />
            <S.AddressBox>
              <ColDiv $gap={4} $padding="24px" $tPadding="24px 16px" $mPadding="16px">
                <RowDiv $alignItems="center" $gap={4}>
                  <Icon name="address" $width={24} $height={24} $padding="0" />
                  <Text $color="secondary700" $type="b7" $fontWeight={500}>
                    ADDRESS
                  </Text>
                </RowDiv>
                <RowDiv $alignItems="center" $gap={12} $justifyContent="space-between" $mFlexDirection="column" $mAlignItems="flex-start" $mGap={8}>
                  <Text $type="b5" $tType="b6" $flex={1}>
                    {list.address}
                  </Text>
                  <S.MapLinkBox>
                    <S.MapLink
                      href={`https://map.kakao.com/link/search/${encodeURIComponent(list.address)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="카카오맵에서 보기"
                    >
                      <S.KakaoMapIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                          fill="#000000"
                        />
                        <circle cx="12" cy="9" r="2.5" fill="#FFFFFF" />
                      </S.KakaoMapIcon>
                    </S.MapLink>
                    <S.MapLink
                      href={`https://map.naver.com/v5/search/${encodeURIComponent(list.address)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      title="네이버맵에서 보기"
                    >
                      <S.NaverMapIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                          fill="#FFFFFF"
                        />
                        <circle cx="12" cy="9" r="2.5" fill="#03C75A" />
                      </S.NaverMapIcon>
                    </S.MapLink>
                  </S.MapLinkBox>
                </RowDiv>
              </ColDiv>
              <RowDiv $gap={24} $mFlexDirection="column" $mGap={9}>
                <ColDiv $gap={4} $flex={3.33} $padding="24px" $tPadding="24px 16px" $mPadding="16px">
                  <RowDiv $alignItems="center" $gap={4}>
                    <Icon name="tel" $width={24} $height={24} $padding="0" />
                    <Text $color="secondary700" $type="b7" $fontWeight={500}>
                      TEL
                    </Text>
                  </RowDiv>
                  <Text $type="b5" $tType="b6">
                    {list.tel}
                  </Text>
                </ColDiv>
                <ColDiv $gap={4} $flex={3.33} $padding="24px" $tPadding="24px 16px" $mPadding="16px">
                  <RowDiv $alignItems="center" $gap={4}>
                    <Icon name="fax" $width={24} $height={24} $padding="0" />
                    <Text $color="secondary700" $type="b7" $fontWeight={500}>
                      FAX
                    </Text>
                  </RowDiv>
                  <Text $type="b5" $tType="b6">
                    {list.fax}
                  </Text>
                </ColDiv>
                <ColDiv $gap={4} $flex={3.33} $padding="24px" $tPadding="24px 16px" $mPadding="16px">
                  <RowDiv $alignItems="center" $gap={4}>
                    <Icon name="mail" $width={24} $height={24} $padding="0" />
                    <Text $color="secondary700" $type="b7" $fontWeight={500}>
                      E-MAIL
                    </Text>
                  </RowDiv>
                  <Text $type="b5" $tType="b6">
                    {list.email}
                  </Text>
                </ColDiv>
              </RowDiv>
            </S.AddressBox>
          </SubWrap>
        </SubSection>
      </SubLayout>
    )
  );
}
